import {inject} from '@angular/core';
import {type CanActivateFn, Router} from '@angular/router';
import {catchError, map, of} from 'rxjs';
import {AuthService} from '@/app/core/services/auth.service';
import {LandingSiteService} from '@/app/features/landing-builder/services/landing-site.service';

/**
 * `/site` (no subdomain) → `/site/:subdomain` for the current tenant's website.
 * Guests / missing site fall back to website builder (or login).
 */
export const redirectToOwnSiteGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const siteApi = inject(LandingSiteService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/auth/login']);
  }

  return siteApi.getMine().pipe(
    map((site) => {
      const subdomain = (site.subdomain || site.organizationName || '').trim();
      if (!subdomain) {
        return router.createUrlTree(['/website-builder']);
      }
      return router.createUrlTree(['/site', subdomain]);
    }),
    catchError(() => of(router.createUrlTree(['/website-builder']))),
  );
};
